exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__header___1hKDQ{font-family:PlayfairDisplay-Regular;font-size:20px;letter-spacing:1.4px;color:#000}", ""]);

// exports
exports.locals = {
	"header": "style__header___1hKDQ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/order-summary/style.css
// module id = 694
// module chunks = 0